/** Remove legacy localStorage tokens (auth uses HttpOnly cookies). */
export const clearStaleAuthStorage = () => {
  if (typeof window === "undefined") return;
  localStorage.removeItem("token");
  localStorage.removeItem("ots_token");
};
